module.exports = __webpack_public_path__ + "img/ng.9d60aa0d.svg";